import { render, staticRenderFns } from "./view-decisions.vue?vue&type=template&id=07c494a2&scoped=true&"
import script from "./view-decisions.vue?vue&type=script&lang=js&"
export * from "./view-decisions.vue?vue&type=script&lang=js&"
import style0 from "./view-decisions.vue?vue&type=style&index=0&id=07c494a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c494a2",
  null
  
)

export default component.exports